import {
  getList,
  getDetail,
  create,
  update,
  deleteSection,
  reorderSection,
  addContent,
  searchVideo,
  reorderContent,
  publishSection,
} from '@/services/videopage';

const getters = {
  listSection: state => state.listSection,
  listContent: state => state.listContent,
  listVideoSearch: state => state.listVideoSearch,
};

const actions = {
  async requestListSection({ commit }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getList();
      commit('SET_LIST_SECTION', { listSection: response.data });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestSearchVideos({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await searchVideo(data);
      commit('SET_LIST_VIDEOS', { listVideoSearch: response.data });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestCreateSection({ commit, dispatch }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await create(data);
      dispatch('requestListSection');
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'success', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-create-section' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestEditSection({ commit, dispatch }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await update(data);
      dispatch('requestListSection');
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'success', errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-edit-section' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDeleteSection({ commit, dispatch }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deleteSection(data);
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'success', errorCode: null }, { root: true });
      dispatch('requestListSection');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-delete-section' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestReorderSection({ commit, dispatch }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await reorderSection(data);
      commit('NotificationModule/SET_STATUS', { status: 200, message: 'success', errorCode: null }, { root: true });
      dispatch('requestListSection');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-delete-section' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailSection({ commit }, id) {
    let response = null;
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      response = await getDetail(id);
      response = response.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
  async requestAddContent({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await addContent(data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestReorderContent({ commit }, { sectionId, data }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await reorderContent(sectionId, data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestPublishSection({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await publishSection(data);
      dispatch('requestListSection');
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
};

const mutations = {
  SET_LIST_SECTION(state, { listSection }) {
    state.listSection = listSection;
  },
  SET_LIST_CONTENT(state, { listContent }) {
    state.listContent = listContent;
  },
  SET_LIST_VIDEOS(state, { listVideoSearch }) {
    state.listVideoSearch = listVideoSearch;
  },
};

export default {
  namespaced: true,
  state: {
    listSection: [],
    listContent: [],
    listVideoSearch: [],
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/VideoPage/index.js